"use client";

import { ContentfulImage } from "@components/ContentfulImage";
import Link from "@components/Link";
import { Accordion } from "@components/ngg";
import type { DesignerPageFragment } from "@server/gql/graphql";

import Icon from "./icon";

export default function Designer({
  title,
  designers,
  readMore,
  locale,
  className,
}: {
  title: string;
  designers?: (DesignerPageFragment | null)[];
  readMore: string;
  locale: string | undefined;
  className?: string;
}) {
  if (!designers?.length) return null;

  return (
    <Accordion
      IconComponent={Icon}
      WrapperComponent="div"
      title={title}
      classNames={{
        wrapper: className,
        button: "text-left items-center leading-4 p-4 uppercase rounded-none",
        panel: "p-4",
      }}
      transitionProps={{ appear: false }}
    >
      {designers.map(
        (designer) =>
          designer && (
            <div className="flex gap-4 lg:gap-6" key={designer.sys.id}>
              {(designer?.desktopImage || designer.mobileImage) && (
                <div className="flex aspect-square h-24 w-24 items-center justify-center bg-gray-100 lg:h-32 lg:w-32">
                  <ContentfulImage
                    desktopImage={designer.desktopImage}
                    mobileImage={designer.mobileImage}
                    className="max-h-full object-contain p-2 mix-blend-multiply"
                    sizes="128px"
                  />
                </div>
              )}

              <div className="flex flex-col gap-1 text-base">
                {designer?.slug ? (
                  <Link
                    locale={locale}
                    className="font-normal"
                    href={designer.slug}
                  >
                    {designer?.title}
                  </Link>
                ) : (
                  <p className="font-normal">{designer?.title}</p>
                )}
                <p>{designer?.shortDescription}</p>
                {designer?.slug && (
                  <Link
                    locale={locale}
                    className="underline underline-offset-1"
                    href={designer.slug}
                  >
                    {readMore}
                  </Link>
                )}
              </div>
            </div>
          ),
      )}
    </Accordion>
  );
}
